import { i18n } from '../main'

export default function (value) {
  return i18n.t(value ? 'yes' : 'no')
}



// WEBPACK FOOTER //
// ./src/filters/yes-no.js